import CellWrapper, { type TableCell } from './CellWrapper';

export default CellWrapper;

export type { TableCell };
